import React, { ChangeEvent, FunctionComponent, useCallback } from 'react';

import { InputQuestionProps } from 'scenes/common/components/Questions/types';
import InputQuestion from 'scenes/common/components/Questions/InputQuestion';

const MAX_NAME_LENGTH = 30;
const VALID_NAME_PATTERN = /^[A-Za-z]+[A-Za-z \-\\'\\`]*$/;

const NameQuestion: FunctionComponent<InputQuestionProps> = ({
  stateKey,
  errors,
  control,
  question,
  defaultValue,
  autoCompleteName,
}) => {
  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>, onChange: Function): void => {
      const { value } = event.target;

      if (!value || value.match(VALID_NAME_PATTERN)) {
        onChange(value);
      }
    },
    []
  );

  return (
    <InputQuestion
      errors={errors}
      control={control}
      stateKey={stateKey}
      defaultValue={defaultValue}
      maxLength={MAX_NAME_LENGTH}
      changeHandler={handleChange}
      autoCompleteName={autoCompleteName}
      validationRules={{ required: true }}
      question={question}
      ariaRequired
    />
  );
};

export default NameQuestion;
